// src/components/BlurOverlay.js

import React, { useState, useEffect } from 'react';
import { Box } from '@mui/material';

// The height of your AppBar. This is now an object to handle responsive heights
// matching TheAppBar's minHeight: { xs: 56, sm: 64 }.
const APP_BAR_HEIGHT = { xs: '56px', sm: '64px' };

export const BlurOverlay = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show the overlay when scrolled more than a small threshold (e.g., 10px)
      if (window.scrollY > 10) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []); // Empty dependency array ensures this runs only once on mount

  return (
    <Box
      sx={{
        position: 'sticky',
        top: APP_BAR_HEIGHT, // MUI handles the responsive value here
        height: '48px',
        width: '100%',
        zIndex: 1090,
        pointerEvents: 'none',
        backdropFilter: 'blur(4px)',
        WebkitBackdropFilter: 'blur(4px)',
        maskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 0%, transparent 100%)',
        
        // Animation styles
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? 'translateY(0)' : 'translateY(-20px)',
        transition: 'opacity 0.3s ease-in-out, transform 0.3s ease-in-out',

        // Add a pseudo-element for the red accent glow
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          // A subtle, top-to-bottom red gradient for a more even glow
          background: 'linear-gradient(to bottom, rgba(216, 41, 47, 0.12) 0%, rgba(216, 41, 47, 0) 80%)',
          zIndex: -1, // Position it behind the blur
        },
      }}
    />
  );
};